import { useState, useCallback } from 'react';
import { NOOP } from '../../../../utils/const.js';
import { KeyboardEventDisparcher } from '../../../Utils/events.js';

/**
 * Custom hook per la gestione dell'elemento corrente di una lista.
 * Gestisce anche la pressione dei tasti (Up, Down, Enter)
 */
function useCurrentListItem(items, onSelected, setShowPopup, onKeyDown = NOOP) {
    const [currentListItem, setCurrentListItem] = useState();
    const handleKeyDown = useCallback((event) => {
        new KeyboardEventDisparcher(event)
            .onEnter(() => {
            const current = currentListItem || items[0];
            if (current) {
                onSelected(currentListItem, event);
                setShowPopup(false);
            }
        })
            .onUp(() => {
            const index = currentListItem ? items.indexOf(currentListItem) : -1;
            if (index > 0) {
                setCurrentListItem(items[index - 1]);
            }
        })
            .onDown(() => {
            setShowPopup(true);
            const index = currentListItem ? items.indexOf(currentListItem) : -1;
            if (index < items.length - 1) {
                setCurrentListItem(items[index + 1]);
            }
        });
        onKeyDown(event);
    }, [currentListItem, items, onKeyDown, onSelected, setShowPopup]);
    const handleItemSelected = useCallback((item, event) => {
        setCurrentListItem(item);
        onSelected(item, event);
    }, [onSelected]);
    return [currentListItem, handleItemSelected, handleKeyDown];
}

export { useCurrentListItem as default };
